import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'
import Login from './components/Login.vue'
import ActivityList from './components/ActivityList.vue'
import ActivityDetail from './components/ActivityDetail.vue'
import QuoteList from './components/QuoteList.vue'
import QuoteDetail from './components/QuoteDetail.vue'
import Settings from './components/Settings.vue'
import Error404 from './components/Error404.vue'
import config from 'config'

Vue.use(Router)

const rootRoute = config.modules.includes('activities') ? '/activities' : '/quotes'

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next(rootRoute)
}

const routes = [
  {
    path: '/',
    redirect: rootRoute
  },
  {
    path: '/login',
    component: Login,
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    meta: { requiresAuth: true }
  }
]

const activityRoutes = [
  {
    path: '/activities',
    name: 'activities',
    component: ActivityList,
    meta: { requiresAuth: true }
  },
  {
    path: '/activities/:id',
    name: 'activityDetail',
    component: ActivityDetail,
    meta: { requiresAuth: true }
  }
]

const quoteRoutes = [
  {
    path: '/quotes',
    name: 'quotes',
    component: QuoteList,
    meta: { requiresAuth: true }
  },
  {
    path: '/quotes/:id',
    name: 'quoteDetail',
    component: QuoteDetail,
    meta: { requiresAuth: true }
  }
]

if (config.modules.includes('activities')) routes.push(...activityRoutes)
if (config.modules.includes('quotes')) routes.push(...quoteRoutes)

// This must be last in the routes array
routes.push({ path: '*', component: Error404 })

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isAuthenticated) next('/login')
    else next()
  } else {
    next()
  }
})

export default router
